"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deletePaymentMethod = exports.createPaymentMethod = exports.fetchPaymentMethods = void 0;

var _tslib = require("tslib");

var _api = require("../api");

var fetchPaymentMethods = function fetchPaymentMethods() {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.get("paymentMethods"
      /* PaymentMethods */
      ).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchPaymentMethods = fetchPaymentMethods;

var createPaymentMethod = function createPaymentMethod(req) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("paymentMethods"
      /* PaymentMethods */
      , req).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.createPaymentMethod = createPaymentMethod;

var deletePaymentMethod = function deletePaymentMethod(paymentToken) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api["delete"]("paymentMethods"
      /* PaymentMethods */
      + "?paymentToken=" + paymentToken).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.deletePaymentMethod = deletePaymentMethod;